import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WithdrawRoutingModule } from './withdraw-routing.module';
import { WithdrawCardComponent } from './withdraw-card/withdraw-card.component';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { WithdrawComponent } from './withdraw.component';


@NgModule({
  declarations: [
    WithdrawCardComponent,WithdrawComponent
  ],
  imports: [
    CommonModule,
    WithdrawRoutingModule,
    SharedModule,
    MatDatepickerModule,
  ],
  
})
export class WithdrawModule { }
